module.exports = __webpack_public_path__ + "media/theme/icon__blog-comment-856587cd.svg";